<template>
	<div>
		<v-toolbar>
			<v-toolbar-title class="text-xs-center">
				<v-text-field v-model="searchText" @change="searchUser" :label="$t('userSearch.label')" class="mt-2 pl-2"></v-text-field>
			</v-toolbar-title>
			<v-btn icon @click="searchUser">
				<v-icon>search</v-icon>
			</v-btn>
		</v-toolbar>
		<v-tabs grow>
			<v-tab v-show="isNoData">{{$t('userSearch.noDataText')}}</v-tab>
			<v-tab-item>
				<v-list>
					<v-list-tile avatar v-for="userDto in userDtoList" v-bind:key="userDto.id" @click="goUserData(userDto.userName)">
						<v-list-tile-avatar>
							<img class="img-responsive rounded-circle posting-img" v-bind:src="userDto.image"/>
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title v-html="userDto.userName" class="aquamarine--text"></v-list-tile-title>
							<v-list-tile-title v-html="userDto.regEmail"></v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>
			</v-tab-item>
		</v-tabs>
	</div>
</template>

<script>
import config from '../config.js'
import {eventBus} from '../assets/js/eventBus.js'
export default {
	data() {
	    return {
	    	searchText: '',				//搜索的文本
	      	userDtoList: [],			//存放用户的集合
	      	isNoData: false,			//是否显示‘没有数据’提示
	    };
	},
	mounted(){
	    
    },
	methods: {
		//路由到用户主页
		goUserData(username){
			this.$router.push({name:'userData', params: {username: '@' + username}})
		},
		//根据用户名模糊搜索用户
		searchUser(){
			if (this.searchText != null && this.searchText.trim() != '') {
				let url = config.baseUrl + "user/open/searchUserContaining/" + this.searchText;
				this.$http.get(url).then(response => {
					let data = response.data;
					if (data.resCode == 0) {
						this.isNoData = false;
						this.userDtoList = data.result;
					}else{
						//没有用户
						this.isNoData = true;
						this.userDtoList = [];
					}
				}, error => {
					//失败也是没有用户
					this.isNoData = true;
					this.userDtoList = [];
				});
			}else {
				//没有条件也是没有用户
				this.isNoData = true;
				this.userDtoList = [];
			}
			
		}
	}
}
</script>



// WEBPACK FOOTER //
// UserSearch.vue?da6d62e2